<template>
  <div v-if="show" class="sidebar-links">
    <router-link to="/operations" :class="{active: isAllOperations}">All Surgeries</router-link>
    <!--
    <router-link to="/operations/add-operation" :class="{active: isActiveAddOperation}">Add Surgery</router-link>
    <router-link to="/operations/upload-operations" v-if="isSurgeon" :class="{active: isActiveUploadOperations}">Add Multiple Surgeries</router-link>
    <router-link to="/operations/nurse-upload-operations" v-if="!isSurgeon" :class="{active: isActiveUploadOperations}">Add Multiple Surgeries</router-link>
    -->
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters(['isSurgeon']),

    path() {
      return this.$route.path
    },

    show() {
      return new RegExp('^/patients').test(this.path) ||
        new RegExp('^/operations').test(this.path) ||
        new RegExp('^/surgeons').test(this.path) ||
        new RegExp('^/users').test(this.path)
    },

    isActiveAddOperation() {
      return this.path === '/operations/add-operation'
    },

    isActiveUploadOperations() {
      return this.path === '/operations/upload-operations' ||
        this.path === '/operations/nurse-upload-operations'
    },

    isAllOperations() {
      return new RegExp('/operations').test(this.path) && !(this.isActiveAddOperation || this.isActiveUploadOperations)
    }
  }
}
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/SideNav/OperationsLinks.vue